function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import { setDay } from "../../../setDay.mjs";
import { Parser } from "../Parser.mjs";
import { mapValue, parseNDigits } from "../utils.mjs"; // Stand-alone local day of week

export var StandAloneLocalDayParser =
/*#__PURE__*/
function (_Parser) {
  _inherits(StandAloneLocalDayParser, _Parser);

  function StandAloneLocalDayParser() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, StandAloneLocalDayParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(StandAloneLocalDayParser)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.priority = 90;
    _this.incompatibleTokens = ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"];
    return _this;
  }

  _createClass(StandAloneLocalDayParser, [{
    key: "parse",
    value: function parse(dateString, token, match, options) {
      var valueCallback = function valueCallback(value) {
        // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case "c":
        case "cc":
          // 03
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
        // 3rd

        case "co":
          return mapValue(match.ordinalNumber(dateString, {
            unit: "day"
          }), valueCallback);
        // Tue

        case "ccc":
          return match.day(dateString, {
            width: "abbreviated",
            context: "standalone"
          }) || match.day(dateString, {
            width: "short",
            context: "standalone"
          }) || match.day(dateString, {
            width: "narrow",
            context: "standalone"
          });
        // T

        case "ccccc":
          return match.day(dateString, {
            width: "narrow",
            context: "standalone"
          });
        // Tu

        case "cccccc":
          return match.day(dateString, {
            width: "short",
            context: "standalone"
          }) || match.day(dateString, {
            width: "narrow",
            context: "standalone"
          });
        // Tuesday

        case "cccc":
        default:
          return match.day(dateString, {
            width: "wide",
            context: "standalone"
          }) || match.day(dateString, {
            width: "abbreviated",
            context: "standalone"
          }) || match.day(dateString, {
            width: "short",
            context: "standalone"
          }) || match.day(dateString, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = setDay(date, value, options);
      date.setHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return StandAloneLocalDayParser;
}(Parser);